import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Container, Skeleton } from "@/components/atoms";
import { ProductCard } from "@/components/molecules";
import { useProducts } from "@/hooks/use-products";
import { getBestsellers } from "@/lib/product-helpers";

// Bestsellers — 5 product cards (frame 21:2).
export function Bestsellers() {
  const { data: products, isLoading } = useProducts();
  const top = getBestsellers(products ?? [], 5);

  return (
    <section className="bg-medical-grey py-14">
      <Container>
        <div className="mb-8 flex items-end justify-between">
          <div>
            <h2 className="font-condensed text-3xl font-bold text-night-blue">
              Bestsellers
            </h2>
            <p className="mt-2 text-night-blue/70">
              The formulas patients reorder most.
            </p>
          </div>
          <Link
            to="/shop"
            className="hidden items-center gap-1 text-sm font-bold text-leaf-green-ink hover:gap-2 sm:inline-flex"
          >
            View all <ArrowRight size={16} />
          </Link>
        </div>
        {isLoading ? (
          /* CLS — a fixed 40vh spinner standing in for a product grid guarantees a shift in
             whichever direction the real grid differs. Card-shaped placeholders do not. */
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
            {Array.from({ length: 2 }, (_, i) => (
              <Skeleton key={i} className="aspect-[3/4] w-full" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
            {top.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}
